import AssessmentParticipantRoute from "./AssessmentParticipantRoute";

function AssessmentParticipantLayout() {
  return <AssessmentParticipantRoute />;
}

export default AssessmentParticipantLayout;
